<section class="p-2 px-md-4 py-md-4">
    <div class="heading-container">
        <div class="heading2">Compare Products</div>
        <div class="float-end close-icon" (click)="close()"><i class="fa-solid fa-xmark"></i></div>
    </div>
    <hr>
    <section>
        <div class="">
            <div class=" table-responsive">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Coverage Name</th>
                            <th>Additional Info</th>
                            <th *ngFor="let product of productDetailes1" class="text-center">
                                {{ product.ProductName }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let coverage of coveragesList1">
                            <tr
                                *ngFor="let data of (coverage.additionalData.length ? coverage.additionalData : [{}]); let i = index">
                                <ng-container *ngIf="i === 0">
                                    <td [attr.rowspan]="coverage.additionalData.length || 1">{{ coverage.CoverageName }}
                                    </td>
                                </ng-container>
                                <td *ngIf="data.AdditionalCoverageLabel">{{ data.AdditionalCoverageLabel }}</td>
                                <td *ngIf="!data.AdditionalCoverageLabel" class="text-center">-</td>
                                <td *ngFor="let product of productDetailes1" class="text-center">
                                    <ng-container
                                        *ngIf="product.coverageQuotesCompare[coverage.CoverageID] && product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]; else noData">
                                        <div class="text-center text-success">
                                            <i class="fa-solid fa-check"></i>
                                        </div>
                                        <div>
                                            {{
                                            product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]
                                            }}
                                        </div>
                                    </ng-container>
                                    <ng-template #noData>
                                        <div class="text-center text-red">
                                            <i class="fa-solid fa-xmark"></i>
                                        </div>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</section>